import { render, staticRenderFns } from "./radial-bar.vue?vue&type=template&id=0dd84b9b&"
import script from "./radial-bar.vue?vue&type=script&lang=js&"
export * from "./radial-bar.vue?vue&type=script&lang=js&"
import style0 from "./radial-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd84b9b')) {
      api.createRecord('0dd84b9b', component.options)
    } else {
      api.reload('0dd84b9b', component.options)
    }
    module.hot.accept("./radial-bar.vue?vue&type=template&id=0dd84b9b&", function () {
      api.rerender('0dd84b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-stats/radial-bar.vue"
export default component.exports